import { Injectable } from '@angular/core'

import { Observable, map, catchError, throwError } from 'rxjs'

import { mappingUserLicense, License } from './license.mapping'
import { GetLicensesGQL } from '../../../_generated/graphql'
import { assertGraphqlData } from '../../util/assertGraphqlData'
import { throwIfCustomError } from '../../util/throwIfCustomError'

@Injectable({
  providedIn: 'root',
})
export class LicenseService {
  constructor(private getLicensesGQL: GetLicensesGQL) {}

  searchLicenses(yearMonth?: string): Observable<License[]> {
    return this.getLicensesGQL.fetch({ variables: { yearMonth } }).pipe(
      map((result) => {
        assertGraphqlData(result)
        return result.data.getLicenses.map(mappingUserLicense)
      }),
      catchError((error: unknown) => {
        throwIfCustomError(error)
        return throwError(() => error)
      }),
    )
  }
}
